var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex aic pl15 pr15 pt15 pb15 bg_fff"},[_c('b',{staticClass:"fs18 flex0 mr10"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"flex1 fs12 color_666"},[_vm._v(_vm._s(_vm.content))]),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }